// languages.js

const languageOptions = [
    { value: "Afrikaans", label: "Afrikaans", label_ar: "الأفريقانية" },
    { value: "Albanian", label: "Albanian", label_ar: "الألبانية" },
    { value: "Amharic", label: "Amharic", label_ar: "الأمهرية" },
    { value: "Arabic", label: "Arabic", label_ar: "العربية" },
    { value: "Armenian", label: "Armenian", label_ar: "الأرمنية" },
    { value: "Azerbaijani", label: "Azerbaijani", label_ar: "الأذربيجانية" },
    { value: "Basque", label: "Basque", label_ar: "الباسكية" },
    { value: "Belarusian", label: "Belarusian", label_ar: "البيلاروسية" },
    { value: "Bengali", label: "Bengali", label_ar: "البنغالية" },
    { value: "Bosnian", label: "Bosnian", label_ar: "البوسنية" },
    { value: "Bulgarian", label: "Bulgarian", label_ar: "البلغارية" },
    { value: "Burmese", label: "Burmese", label_ar: "البورمية" },
    { value: "Catalan", label: "Catalan", label_ar: "الكتالونية" },
    { value: "Cebuano", label: "Cebuano", label_ar: "سيبوانو" },
    { value: "Chinese (Simplified)", label: "Chinese (Simplified)", label_ar: "الصينية (المبسطة)" },
    { value: "Chinese (Traditional)", label: "Chinese (Traditional)", label_ar: "الصينية (التقليدية)" },
    { value: "Croatian", label: "Croatian", label_ar: "الكرواتية" },
    { value: "Czech", label: "Czech", label_ar: "التشيكية" },
    { value: "Danish", label: "Danish", label_ar: "الدنماركية" },
    { value: "Dutch", label: "Dutch", label_ar: "الهولندية" },
    { value: "English", label: "English", label_ar: "الإنجليزية" },
    { value: "Estonian", label: "Estonian", label_ar: "الإستونية" },
    { value: "Finnish", label: "Finnish", label_ar: "الفنلندية" },
    { value: "French", label: "French", label_ar: "الفرنسية" },
    { value: "Georgian", label: "Georgian", label_ar: "الجيورجية" },
    { value: "German", label: "German", label_ar: "الألمانية" },
    { value: "Greek", label: "Greek", label_ar: "اليونانية" },
    { value: "Gujarati", label: "Gujarati", label_ar: "الغوجاراتية" },
    { value: "Haitian Creole", label: "Haitian Creole", label_ar: "كريول هايتي" },
    { value: "Hausa", label: "Hausa", label_ar: "الهوسا" },
    { value: "Hawaiian", label: "Hawaiian", label_ar: "الهاوايية" },
    { value: "Hebrew", label: "Hebrew", label_ar: "العبرية" },
    { value: "Hindi", label: "Hindi", label_ar: "الهندية" },
    { value: "Hungarian", label: "Hungarian", label_ar: "الهنغارية" },
    { value: "Icelandic", label: "Icelandic", label_ar: "الأيسلندية" },
    { value: "Igbo", label: "Igbo", label_ar: "الإيبو" },
    { value: "Indonesian", label: "Indonesian", label_ar: "الإندونيسية" },
    { value: "Irish", label: "Irish", label_ar: "الأيرلندية" },
    { value: "Italian", label: "Italian", label_ar: "الإيطالية" },
    { value: "Japanese", label: "Japanese", label_ar: "اليابانية" },
    { value: "Javanese", label: "Javanese", label_ar: "الجاوية" },
    { value: "Kannada", label: "Kannada", label_ar: "الكانادا" },
    { value: "Kazakh", label: "Kazakh", label_ar: "الكازاخستانية" },
    { value: "Khmer", label: "Khmer", label_ar: "الخميرية" },
    { value: "Korean", label: "Korean", label_ar: "الكورية" },
    { value: "Kurdish", label: "Kurdish", label_ar: "الكردية" },
    { value: "Kyrgyz", label: "Kyrgyz", label_ar: "القيرغيزية" },
    { value: "Lao", label: "Lao", label_ar: "اللاوية" },
    { value: "Latin", label: "Latin", label_ar: "اللاتينية" },
    { value: "Latvian", label: "Latvian", label_ar: "اللاتفية" },
    { value: "Lithuanian", label: "Lithuanian", label_ar: "الليتوانية" },
    { value: "Luxembourgish", label: "Luxembourgish", label_ar: "اللوكسمبرجية" },
    { value: "Macedonian", label: "Macedonian", label_ar: "المقدونية" },
    { value: "Malagasy", label: "Malagasy", label_ar: "المالاجاشية" },
    { value: "Malay", label: "Malay", label_ar: "الماليزية" },
    { value: "Malayalam", label: "Malayalam", label_ar: "المالايالامية" },
    { value: "Maltese", label: "Maltese", label_ar: "المالطية" },
    { value: "Maori", label: "Maori", label_ar: "الماورية" },
    { value: "Marathi", label: "Marathi", label_ar: "الماراثية" },
    { value: "Mongolian", label: "Mongolian", label_ar: "المنغولية" },
    { value: "Nepali", label: "Nepali", label_ar: "النيبالية" },
    { value: "Norwegian", label: "Norwegian", label_ar: "النرويجية" },
    { value: "Pashto", label: "Pashto", label_ar: "البشتونية" },
    { value: "Persian", label: "Persian", label_ar: "الفارسية" },
    { value: "Polish", label: "Polish", label_ar: "البولندية" },
    { value: "Portuguese", label: "Portuguese", label_ar: "البرتغالية" },
    { value: "Punjabi", label: "Punjabi", label_ar: "البنجابية" },
    { value: "Romanian", label: "Romanian", label_ar: "الرومانية" },
    { value: "Russian", label: "Russian", label_ar: "الروسية" },
    { value: "Serbian", label: "Serbian", label_ar: "الصربية" },
    { value: "Sesotho", label: "Sesotho", label_ar: "السوتو" },
    { value: "Shona", label: "Shona", label_ar: "الشونا" },
    { value: "Sindhi", label: "Sindhi", label_ar: "السندية" },
    { value: "Sinhala", label: "Sinhala", label_ar: "السينهالية" },
    { value: "Slovak", label: "Slovak", label_ar: "السلوفاكية" },
    { value: "Slovenian", label: "Slovenian", label_ar: "السلوفينية" },
    { value: "Somali", label: "Somali", label_ar: "الصومالية" },
    { value: "Spanish", label: "Spanish", label_ar: "الإسبانية" },
    { value: "Sundanese", label: "Sundanese", label_ar: "السوندانية" },
    { value: "Swahili", label: "Swahili", label_ar: "السواحيلية" },
    { value: "Swedish", label: "Swedish", label_ar: "السويدية" },
    { value: "Tajik", label: "Tajik", label_ar: "الطاجيكية" },
    { value: "Tamil", label: "Tamil", label_ar: "التاميلية" },
    { value: "Telugu", label: "Telugu", label_ar: "التيلجو" },
    { value: "Thai", label: "Thai", label_ar: "التايلاندية" },
    { value: "Turkish", label: "Turkish", label_ar: "التركية" },
    { value: "Ukrainian", label: "Ukrainian", label_ar: "الأوكرانية" },
    { value: "Urdu", label: "Urdu", label_ar: "الأردية" },
    { value: "Uzbek", label: "Uzbek", label_ar: "الأوزبكية" },
    { value: "Vietnamese", label: "Vietnamese", label_ar: "الفيتنامية" },
    { value: "Welsh", label: "Welsh", label_ar: "الويلزية" },
    { value: "Xhosa", label: "Xhosa", label_ar: "الخوسا" },
    { value: "Yiddish", label: "Yiddish", label_ar: "اليديشية" },
    { value: "Yoruba", label: "Yoruba", label_ar: "اليوروبا" },
    { value: "Zulu", label: "Zulu", label_ar: "الزولو" }
  ];
  
  export default languageOptions;
